import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import { asyncConnect } from 'redux-async-connect'
import CSSModules from 'react-css-modules'
// import Helmet from 'react-helmet'
import config from '../../config'
import {
  Grade,
  Link,
  LinkIcon,
  AboutBanner,
  DonateBanner,
  GetStartedInput,
  ScreenedCompanies,
  SrOnly
} from '../../components'
import Styles from './FAQ.css'
import container from '../../helpers/container'


@CSSModules(Styles)
export default class FAQ extends Component {
  static propTypes = {}

  constructor(props) {
    super(props)
    this.state = {}
  }

  renderTop = ()=>{
    return (
      <Link
        to='#top'
        title='Back to top'
      >
        <div styleName='link-to-top'>
          Back to top<LinkIcon faclass='fa-angle-double-up'/>
        </div>
      </Link>
    )
  }

  renderQuestions = () => {
    return (
      <div styleName='questions'>
        <Link to='#1' title='What is Tobacco Free Funds?'>
          <div styleName='question'>
            1. What is Tobacco Free 
            Funds?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#2' title='Why entertainment companies?'>
          <div styleName='question'>
            2. What do entertainment companies have to do with
            tobacco?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#3' title='How do entertainment companies compare?'>
          <div styleName='question'>
            3. How do entertainment companies
            compare?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#4' title='Where does the tobacco grade come from?'>
          <div styleName='question'>
            4. Where does the &ldquo;Tobacco Grade&rdquo; come
            from?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#5' title='What are socially responsible funds?'>
          <div styleName='question'>
            5. What are socially responsible funds? What about funds that
            engage the companies they own to push for better
            behavior?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link
          to='#6'
          title='What companies do you look for when funds are screened?'
        >
          <div styleName='question'>
            6. What companies do you look for when funds are
            screened?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#7' title='Why do you emphasize 401(k)?'>
          <div styleName='question'>
            7. Why do you emphasize 401(k)&rsquo;s? Does the tool work for
            other types of investment
            vehicles?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#8' title='Who is As You Sow?'>
          <div styleName='question'>
            8. Who is As You Sow?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#9' title='Where do you get your data?'>
          <div styleName='question'>
            9. Where do you get your
            data?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <Link to='#10' title='Where can I learn more about this?'>
          <div styleName='question'>
            10. Where can I learn more about
            this?<LinkIcon faclass='fa-angle-double-down' />
          </div>
        </Link>
        <div styleName='another-question'>
          <span>Have another question? </span>
          <Link
            xstrong
            styleName='contact'
            to={config.links.contact}
            title='Contact us'
          >
            Contact us<LinkIcon />
          </Link>
        </div>
      </div>
    )
  }

  renderAnswers = () => {
    // IMAGES
    const sriIcon = require('../../../static/images/sri.png')
    const ussifLogo = require('../../../static/images/ussif-logo.png')

    //
    return (
      <div styleName='answers'>

        { /* ANSWER 1 */ }
        <div styleName='answer'>
          <div styleName='anchor' id='1'/>
          <div styleName='answer-title'>
            1. What is Tobacco Free Funds?
          </div>
          <div styleName='answer-info'>
            <p>
              <strong>Tobacco Free Funds</strong> is a search platform that
              enables you to find out if your savings are being used to fund
              companies that produce tobacco products or promote tobacco to
              kids. We also help you find investment options that support a
              cleaner and healthier future.
            </p>
            <p>
              Tobacco is the #1 cause of preventable death in the U.S.,
              causing <Link
                to='https://www.cdc.gov/mmwr/preview/mmwrhtml/mm5745a3.htm'
                xstrong
              >half a million deaths a year in the U.S.
              alone.</Link> <Link
                to={
                  'http://publications.iarc.fr/Non-Series-Publications/' +
                    'World-Cancer-Reports/World-Cancer-Report-2014'
                }
                xstrong
              >Tobacco use is increasing globally,</Link> particularly in the
              developing world. <Link
                to={
                  'http://apps.who.int/iris/bitstream/10665/43818/1/' +
                    '9789241596282_eng.pdf'
                }
                xstrong
              >One billion lives are at stake in the battle against tobacco
              addiction this century.</Link> <Link
                to={config.links.reader}
                strong
                title='Download Acrobat Reader to view this PDF'
              ><i className='fa fa-file-pdf-o'></i><SrOnly>Download Acrobat
              Reader to view this PDF</SrOnly></Link> The World Health
              Organization describes tobacco as the most devastating, but
              preventable, epidemic of our time.
            </p>
            <p>
              <Link
                xstrong
                to={config.routes.clean}
                title='Top Scoring Funds | Tobacco Free Funds'
              >Click to here to see a list of funds that avoid tobacco
              investments.</Link>
            </p>
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 2 */ }
        <div styleName='answer'>
          <div styleName='anchor' id='2'/>
          <div styleName='answer-title'>
            2. What do entertainment companies have to do with tobacco?
          </div>
          <div styleName='answer-info'>
            <p>
              There is scientific consensus that exposure to tobacco in movies
              causes kid to begin smoking. Learn about the history, research,
              and company analysis below.
            </p>
            <div styleName='answer-subtitle'>
              The History
            </div>
            <p>
              The U.S. and other countries have long tried to halt tobacco
              promotion to children and adolescents. In 1971, <Link
                to={
                  'https://www.cdc.gov/tobacco/data_statistics/by_topic/' +
                    'policy/legislation/'
                }
                xstrong
              >Congress banned tobacco commercials on radio and
              television.</Link> In the 1980s and 1990s, restrictions were
              negotiated on tobacco advertising in print media and on
              billboards. Yet depictions of smoking continue in movies and on
              television. <Link
                to={
                  'https://www.surgeongeneral.gov/library/reports/' +
                    'preventing-youth-tobacco-use/'
                }
                xstrong
              >The scientific consensus is that tobacco imagery causes kids to
              begin smoking.</Link>
            </p>
            <p>
              The history of collaboration between the film and tobacco
              industries is well-documented, including by <Link
                to='https://www.cdc.gov/tobacco/data_statistics/sgr/2012/'
                xstrong
              >the U.S. Surgeon General</Link>. From the late 1920s to at
              least the mid-1990s, tobacco companies paid millions of dollars
              to place their products in entertainment media accessible to
              kids. These cross-promotion and product placement deals were in
              addition to the millions in advertising dollars that tobacco
              companies paid to the major studios' television production arms
              and to broadcast networks.
            </p>
            <p>
              The historic 1998 legal settlement with state Attorneys General
              (the <Link
                to={
                  'http://www.publichealthlawcenter.org/topics/' +
                    'tobacco-control/tobacco-control-litigation/' +
                    'master-settlement-agreement'
                }
                xstrong
              >&ldquo;Master Settlement Agreement&rdquo;</Link>) barred
              tobacco companies from paying to place their brands in U.S.
              movies and TV shows accessible to children and adolescents. Over
              the past decade, 180 nations and other territories have become
              parties to the <Link
                to='http://www.who.int/fctc/'
                xstrong
              >World
              Health Organization Framework Convention on Tobacco
              Control</Link> (FCTC) Article 13, which commits countries to
              eliminating tobacco promotion on all media platforms, including
              film. The United States signed but did not ratify this treaty.
              No U.S. law or regulation currently bars tobacco product
              placement in media accessible to children and adolescents. And
              the Master Settlement Agreement with U.S. tobacco firms does not
              prevent any film or television producer or distributor in the
              U.S. from making a promotional deal with a multinational tobacco
              company or its agents.
            </p>
            <div styleName='answer-subtitle'>
              The Research
            </div>
            <p>
              In 2012, the U.S. Surgeon General reviewed extensive scientific
              literature and concluded that <Link
                to={
                  'https://www.surgeongeneral.gov/library/reports/' +
                    'preventing-youth-tobacco-use/'
                }
                xstrong
              >exposure to smoking on screen causes kids to smoke</Link>. This
              seminal report concluded that an R-rating for future movies with
              smoking would lower teen smoking rates by 18 percent and <Link
                to={
                  'https://smokefreemovies.ucsf.edu/research/' +
                    'key-reports/cdc-fact-sheets'
                }
                xstrong
              >prevent one million tobacco deaths among kids alive
              today</Link>.
            </p>
            <p>
              In July 2017, <Link
                to={
                  'https://www.cdc.gov/mmwr/volumes/66/wr/' +
                    'mm6626a1.htm?s_cid=mm6626a1_w'
                }
                xstrong
              >CDC’s Morbidity and Mortality Weekly Report (MMWR)</Link> noted
              that “the steady decline in the number of tobacco incidents in
              youth-rated movies from 2005–2010 stopped after 2010” and
              re-affirmed the necessity for R-rating movies with smoking. The
              CDC report, covered in <Link
                to={
                  'https://www.nytimes.com/2017/07/17/well/family/' +
                    'why-smoking-in-films-harms-children.html'
                }
                xstrong
              >The New York Times</Link>, credited investors with helping to
              reduce tobacco imagery in kid-rated movies.
            </p>
            <p>
              However, the Motion Picture Association of America, the trade
              group for the major studios that governs the U.S. movie rating
              system, has repeatedly refused to adopt the R-rating for
              smoking.
            </p>
            <p>
              In August 2017, 17 leading U.S. health organizations (including
              American Cancer Society and medical organizations representing
              more than 630,000 doctors) <Link
                to={
                  'https://www.aap.org/en-us/about-the-aap/' +
                    'aap-press-room/Pages/Leading-Health-Groups-Demand-' +
                    'Film-Industry-Give-R-Rating-to-Movies-That-Depict-' +
                    'Smoking.aspx'
                }
                xstrong
              >demanded that movie producers, distributors and exhibitors
              apply an R rating to all films that include depictions of
              smoking or tobacco</Link>.
            </p>
            <div styleName='answer-subtitle'>
              The definition of a “Tobacco Free” entertainment company
            </div>
            <ol type='a'>
              <li>
                Stipulates in its distribution and licensing agreements that
                exhibition of any video content with tobacco imagery will be
                preceded by a strong anti-tobacco spot announcement, in all
                media and in all distribution territories;
              </li>
              <li>
                Requires each credited producer of a video content with
                tobacco imagery to file affidavits stating that nobody
                associated with the video content production entered into any
                agreement in regard to the representation of tobacco in the
                video content;
              </li>
              <li>
                Stipulates in all production agreements that the finished
                video content shall not include any tobacco product brand or
                facsimile;
              </li>
              <li>
                Stipulates in all production agreements that there should be
                no tobacco imagery in any video content conceived to be
                youth-rated, with the possible exception of video content that
                depicts tobacco use only by an actual historical person (as in
                a documentary or a biographical drama) or accurately
                portrays the serious health consequences of tobacco use.
              </li>
              <li>
                Further, that the company (if it is an MPAA member), in its
                role on the governing board of the Motion Picture Association
                of America, explicitly supports updating the rating and
                advertising standards and guidelines to assign an R-rating to
                any video content with tobacco imagery, with the possible
                exceptions stated at (d).
              </li>
            </ol>
            <div styleName='answer-subtitle'>
              Who is responsible?
            </div>
            <p>
              Tobacco Free Funds identifies five equities that own major
              (MPAA-member) video production studios:
            </p>
            <ul>
              <li>
                Comcast (Universal, Focus)
              </li>
              <li>
                Disney (Disney, 21st Century Fox, Marvel, Lucasfilm, Pixar,
                Touchstone)
              </li>
              <li>
                Sony (Sony Pictures, Columbia, Screen Gems)
              </li>
              <li>
                AT&T (Time Warner, Warner Bros., New Line)
              </li>
              <li>
                ViacomCBS (Paramount)
              </li>
            </ul>
            <p>
              Tobacco Free Funds also identifies one equity that owns a large
              non-MPAA member studio:
            </p>
            <ul>
              <li>
                Lions Gate Entertainment (Lionsgate)
              </li>
            </ul>
            <p>
              Additionally, four equities have been identified that produce
              original video content that is shared through online streaming
              services. These companies have not been included in the current
              Tobacco Free Funds entertainment companies screen, meaning they
              don't affect a mutual fund's Tobacco Free Funds grade, because
              insufficient data has been processed about the companies'
              tobacco exposure. However, they will be monitored for possible
              future inclusion.  
            </p>
            <ul>
              <li>
                Netflix (Netflix Originals)
              </li>
              <li>
                Amazon (Amazon Studios)
              </li>
              <li>
                Apple (Apple TV+)
              </li>
              <li>
                Google (Youtube TV)
              </li>
            </ul>
            <p>
              Tobacco Free Funds screens could be extended to other industries
              if scientific research finds that these companies are
              responsible for recruiting new smokers. When data collection is
              in place, Tobacco Free Funds may include:
            </p>
            <ul>
              <li>
                Cable and satellite companies such as Charter and Dish without
                appropriate notifications and safeguards at product selection
                or point-of-purchase.
              </li>
              <li>
                Video streaming services which lack appropriate notifications
                and safeguards at product selection or point-of-purchase for
                third-party entertainment products with tobacco imagery.  
              </li>
              <li>
                Film exhibitors and video retailers such as Cinemark, Regal,
                Best Buy, Redbox, and Target without appropriate notifications
                and safeguards at point-of-purchase of entertainment products
                with tobacco imagery.
              </li>
            </ul>
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 3 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='3'/>
          <div styleName='answer-title'>
            3. How do entertainment companies compare?
          </div>
          <div styleName='answer-info'>
            <p>
              None of the major movie studios are &ldquo;Tobacco Free&rdquo;.
            </p>
            <p>
              Six publicly-traded parent companies own major movie studios:
            </p>
            <ul>
              <li>
                Comcast (Universal, Focus)
              </li>
              <li>
                Disney (Disney, 21st Century Fox, Lucasfilm, Marvel, Pixar, Touchstone)
              </li>
              <li>
                Lions Gate Entertainment (Lionsgate)
              </li>
              <li>
                Sony (Sony, Columbia, Screen Gems)
              </li>
              <li>
                AT&T (Time Warner, Warner Bros., New Line)
              </li>
              <li>
                ViacomCBS (Paramount, CBS Films)
              </li>
            </ul>
            <p>
              By 2013, all major movie studios or their parent companies had
              adopted tobacco depiction policies that may discourage but do
              not eliminate smoking in their youth-rated movies (see chart
              below). Sizeable loopholes in these policies, such as allowing
              smoking for “creative” reasons, have prevented smoking incidents
              in PG-13 films industry-wide from falling since 2010. In 2016,
              more than one in three PG-13 movies from MPAA-member studios
              still featured smoking.
            </p>
            <p>
              Among the major studios, Sony and ViacomCBS ranks as the
              smokiest with 50 percent of youth-rated movies featuring smoking
              from the year they adopted their first policy until 2019. All
              other studios (Comcast, Disney, AT&T) had between 41-44% of
              movies with tobacco use.
            </p>
            <div styleName='answer-subtitle'>
              Comparison of studios by smoking policy from the year they
              adopted their first policy through 2019
            </div>
            <p>
              <Link
                to={
                  'https://smokefreemovies.ucsf.edu/whos-accountable/' +
                    'company-policies'
                }
                xstrong
                title={
                  'Adapted from Smokefree Movies, University of ' +
                    'California, San Francisco'
                }
              >
                <em>Adapted from Smokefree Movies, University of California,
                San Francisco</em>
              </Link>
            </p>

            { /* TABLE OF STUDIO POLICIES */ }
            <table styleName='company-table'>
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Policy date</th>
                  <th>Subjective exceptions</th>
                  <th>Youth-rated films w/ smoking</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <Link
                      to='https://smokefreemovies.ucsf.edu/company/comcast'
                      xstrong
                      title='Comcast (Universal) | UCSF Smoke Free Movies'
                    >
                      Comcast (Universal)
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/' +
                          'Comcast policy 2007 v080420.docx'
                      }
                      xstrong
                      title='Comcast 2007 | UCSF Smoke Free Movies'
                    >2007</Link>
                  </td>
                  <td>
                    "importance [from a] factual or creative
                    standpoint...difficulty in removing it"
                  </td>
                  <td>
                    41%
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to='https://smokefreemovies.ucsf.edu/company/disney'
                      xstrong
                      title='Disney | UCSF Smoke Free Movies'
                    >
                      Disney
                    </Link>
                  </td>
                  <td>
                    2007, <Link
                      to={
                        'http://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/' +
                          'Disney policy 2012.docx'
                      }
                      xstrong
                      title='Disney 2012 | UCSF Smoke Free Movies'
                    >2012</Link>, <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/' +
                          'Disney policy v080420.docx'
                      }
                      xstrong
                      title='Disney 2015 | UCSF Smoke Free Movies'
                    >2015</Link>
                  </td>
                  <td>
                    Portrayals of "smoking in an unfavorable light or [that]
                    emphasize the negative consequences"
                  </td>
                  <td>
                    44%
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to='https://smokefreemovies.ucsf.edu/company/sony'
                      xstrong
                      title='Sony | UCSF Smoke Free Movies'
                    >
                      Sony
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/' +
                          'Sony policy 2012 v080420.docx'
                      }
                      xstrong
                      title='Sony 2012 | UCSF Smoke Free Movies'
                    >2012</Link>
                  </td>
                  <td>
                    "important tie to the creative context of the project or
                    the creative vision of the filmmaker"
                  </td>
                  <td>
                    50%
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/company/time-warner'
                      }
                      xstrong
                      title='AT&T (Time Warner) | UCSF Smoke Free Movies'
                    >
                      AT&T (Time Warner)
                    </Link>
                  </td>
                  <td>
                    2005, 2007, <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/' +
                          'ATT policy v080420_0.docxf'
                      }
                      xstrong
                      title='AT&T (Time Warner) 2018 | UCSF Smoke Free Movies'
                    >2018</Link>
                  </td>
                  <td>
                    "compelling creative reason"
                  </td>
                  <td>
                    42%
                  </td>
                </tr>
                <tr>
                  <td>
                    <Link
                      to='https://smokefreemovies.ucsf.edu/company/viacom'
                      xstrong
                      title='ViacomCBS (Paramount) | UCSF Smoke Free Movies'
                    >
                      ViacomCBS (Paramount)
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={
                        'https://smokefreemovies.ucsf.edu/sites/' +
                          'smokefreemovies.ucsf.edu/files/Viacom policy 2013 v080420.docx'
                      }
                      xstrong
                      title='Viacom 2013 | UCSF Smoke Free Movies'
                    >2013</Link>
                  </td>
                  <td>
                    "creative vision...filmmaker believes that the depiction
                    of smoking or tobacco is important to the film"
                  </td>
                  <td>
                    50%
                  </td>
                </tr>
              </tbody>
            </table>
            { /* <div
              styleName='faq-graph-img-2'
              title={
                'Chart of Percentage of Youth-Rated Movies with Smoking ' +
                  '2013-2016 by Studio'
              }
            /> */ }
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 4 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='4'/>
          <div styleName='answer-title'>
            4. Where does the "Tobacco Grade" come from?
          </div>
          <div styleName='answer-info'>
            <p>
              Tobacco Free Funds scans mutual fund holdings for two types of companies: <strong>tobacco companies</strong>, and <strong>tobacco-promoting entertainment companies</strong>. If any companies on our screen lists are found in a mutual fund's portfolio, we calculate the overall exposure. <Link xstrong to={'#6'} title='FAQ: What companies do you look for when funds are screened?'>See below the lists of the specific companies we screen for.</Link>
            </p>
            <p>
              Based on whether or not a fund has investment in tobacco
              companies and/or tobacco-promoting entertainment companies,
              we assign a letter grade.
            </p>
            <div styleName='risk-bullet'>
              <Grade grade={1} large/>
              <p styleName='screen-icon-label'>
                No holdings flagged for our tobacco screens. Assigned a grade of A.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={2} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in tobacco-promoting entertainment companies, but no holdings flagged for our tobacco producer screen. Assigned a grade of B.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={3} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in tobacco producers, below the threshold of 0.5%. Assigned a grade of C.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={4} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in tobacco producers, above the threshold of 0.5% and below 1.2%. Assigned a grade of D.
              </p>
            </div>
            <div styleName='risk-bullet'>
              <Grade grade={5} large/>
              <p styleName='screen-icon-label'>
                Fund is invested in tobacco producers, above the threshold of 1.2%. Assigned a grade of F.
              </p>
            </div>
            <p>
              These thresholds reflect the distribution of results across
              funds, placing an approximately equal number of funds from the
              analysis universe in the C, D, and F grade ranges.
            </p>
            { /*
            <p>If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as <Link xstrong to={'https://go.asyousow.org/take-action-tobacco-free-funds'} title='Read the investor letter signed by firms managing over $64 billion in assets'>signing our Investor Statement on Tobacco Depictions in Movies,</Link> it earns a special acknowledgement as a “known sustainability engager”, instead of a letter grade.</p>
            <div styleName='risk-bullet'>
              <Grade grade={1.5} large/>
              <p styleName='screen-icon-label'>
                “Known sustainability engager” grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.
              </p>
            </div>
            <p><Link xstrong to={config.routes.faq+'#5'} title={'More about how fund managers engage companies on tobacco in youth entertainment'}> Read more about how fund managers engage companies on tobacco in youth entertainment.</Link></p>
            <p><Link xstrong to={config.routes.works}>For more on our screening methodology, visit our How it Works page.</Link></p>
            <br/>
            */}
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 5 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='5'/>
          <div styleName='answer-title'>
            5. What are sustainable funds?
          </div>
          <div styleName='answer-info'>
            <img styleName='sri' src={sriIcon} alt='Sustainable fund icon'/>
            <p><strong>Sustainable funds</strong> make investment decisions based on issues like environmental responsibility, human rights, or religious views. A socially responsible fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are socially responsible.</p>
            <img styleName='ussif' src={ussifLogo} alt='US-SIF - The Forum for Sustainable and Responsible Investment icon'/>
            <p><strong>US-SIF - <Link xstrong to={config.links.ussif} title='US-SIF - The Forum for Sustainable and Responsible Investment'>The Forum for Sustainable and Responsible Investment</Link></strong> is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies involved in the production, licensing, and/or retailing of tobacco products, or in the manufacturing of products necessary for production of tobacco products. Look for this symbol to find funds that are members of US-SIF.</p>
            { /*
            <div styleName="engagement-icon-flexcontainer"><Grade grade={1.5} large/><span styleName='engagement-icon-headline'>engagement</span></div>
            <p>Some socially responsible funds go further, actively engaging the companies they own to promote sustainability and long-term value. Indeed, efforts by socially responsible investors whose funds are found on this site have been crucial to driving positive change at movie studios. Shareholder pressure helped drive Disney to pledge to remove smoking from all films that it produces rated PG-13 or lower.</p>
            <p>A number of fund families have taken actions such as signing investor letters, or filing <Link xstrong to={config.links.aysvoteshares} title='As You Sow: Vote your shares'>shareholder resolutions</Link> asking for social and environmental policy changes at the companies they invest in. These fund managers deserve special acknowledgement - often, they’re using their investments to make sure they have a voice at the table to call for real improvements in company behavior.</p>
            <p>We identified fund families that have <Link xstrong to={config.links.speakout} title='Take action: Tell Hollywood to take smoking out of kid rated movies!'>signed investor letters</Link>, filed shareholder resolutions, or otherwise shown a commitment to engaging the entertainment companies they own on tobacco issues. If a fund is invested in entertainment companies, but the fund family is a known engager, it earns a special score. Look for the engagement symbol to find funds from asset managers that engage entertainment companies on tobacco issues.</p>
            <p><strong>Are you a fund manager that has filed a social or environment-related shareholder resolution, or otherwise engage the companies you own on tobacco public health issues?</strong> <Link xstrong styleName='contact' to={'#contact'} title='Contact us'>Get in touch - we’d love to hear from you.</Link></p>
            */}
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 6 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='6'/>
          <div styleName='answer-title'>
            6. What companies do you look for when funds are screened?
          </div>
          <div styleName='answer-info'>
            <p>Two screens are applied to each fund – a list of tobacco producers and manufacturers of tobacco products, and a list of entertainment companies that promote tobacco to kids by failing to properly rate their films.</p>
            { /* this.renderTobaccoCompaniesTableButton() */ }
            { /* this.renderMediaCompaniesTableButton() */ }

            <ScreenedCompanies />

            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 7 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='7'/>
          <div styleName='answer-title'>
            7. Why do you emphasize 401(k)’s? Does the tool work for other types of investment vehicles?
          </div>
          <div styleName='answer-info'>
            <p>For many of us, the majority of our investments are in 401(k) plans offered by our employers. 401(k)s invest mostly through mutual funds and exchange-traded funds (ETFs). But those funds can invest in a wide array of securities, and it&rsquo;s not always easy for investors to investigate what’s inside the funds they own. You can spend hours poring over mutual fund prospectuses, and still not fully grasp everything your 401(k) is invested in. Your retirement money may be invested in economically and morally risky tobacco companies.</p>
            <p>But regardless of how your money is invested &mdash; whether through a 401(k), a traditional or Roth IRA, a pension fund or other vehicle &mdash; if you hold mutual funds, we can help you analyze them for tobacco holdings.</p>
            <p>You can request that your employer include Tobacco Free options in your 401(k) plan &mdash; <Link xstrong to={config.routes.toolkit} title='401k toolkit'>learn how.</Link></p>
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 8 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='8' />
          <div styleName='answer-title'>
            8. Who is As You Sow?
          </div>
          <div styleName='answer-info'>
            <p><Link xstrong to={config.links.ays} title='As You Sow'>As You Sow</Link> promotes environmental and social corporate responsibility through shareholder advocacy, coalition building, innovative legal strategies, and online financial transparency tools. We are the nation&rsquo;s leading non-profit organization practicing direct shareholder engagement on environmental, social, and governance issues. Founded in 1992, As You Sow believes that corporations must be willing participants in solutions to most of today’s pressing issues; and we believe that shareholders are the single most powerful force for motivating that participation. We use that power to protect health and the environment and to create positive, lasting change in corporate behavior for the long-term benefit of humanity.</p>
            <p>In 2015, we launched <Link xstrong to={config.links.fff} title='Fossil Free Funds'>Fossil Free Funds</Link> so that people could see if their retirement was funding climate change. In 2016, we followed up with <Link xstrong to={config.links.dff} title='Deforestation Free Funds'>Deforestation Free Funds</Link>. We are committed to transparency, corporate accountability, and empowering individuals to take control of their investments.</p>
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 9 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='9'/>
          <div styleName='answer-title'>
            9. Where do you get your data?
          </div>
          <div styleName='answer-info'>
            <p>The financial data powering Tobacco Free Funds is sourced from Morningstar. Morningstar, Inc. is a leading provider of independent investment research in North America, Europe, Australia, and Asia. The company works directly with investors and financial advisors to create products that help them meet their personal financial goals, providing the most reliable and pertinent information available on investment vehicles across industries. Morningstar provides data on approximately 500,000 investment offerings, including U.S. stocks and mutual funds, along with real-time global market data on more than 14 million equities and indexes, as well as foreign exchange and Treasury markets.</p>
            <p>Tobacco companies are identified using Morningstar industry classifications. Under Morningstar&rsquo;s Global Equity Classification Structure, each equity is mapped into one of 148 industries that most accurately reflects the underlying business of that company. This mapping is based on publicly available information about each company using annual reports, Form 10-Ks, and Morningstar Equity Analyst input as its primary source. Other secondary sources of information may include company websites, sell-side research (if available), and trade publications.</p>
            <p><Link to={'http://corporate.morningstar.com/EquityClassifications/'} xstrong title='Morningstar industry classifications'>See the full list of Morningstar industry classifications</Link></p>
            {this.renderTop()}
          </div>
        </div>

        { /* ANSWER 10 */ }
        <div styleName='answer' >
          <div styleName='anchor' id='10'/>
          <div styleName='answer-title'>
            10. Where can I learn more?
          </div>
          <div styleName='answer-info'>
            <div styleName='answer-subtitle'>
              Media
            </div>
            <ul>
              <li><Link to={'http://tobaccocontrol.bmj.com/content/11/suppl_1/i81.full'} xstrong title='How the Tobacco Industry Built its Relationship with Hollywood'>How the Tobacco Industry Built its Relationship with Hollywood</Link></li>
              <li><Link to={'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2596576/'} xstrong title='Fiscal Versus Social Responsibility: How Philip Morris Shaped the Public Funds Divestment Debate'>Fiscal Versus Social Responsibility: How Philip Morris Shaped the Public Funds Divestment Debate</Link></li>
              <li><Link to={'http://www.encognitive.com/node/7270'} xstrong title='Tobacco Divestment: A New Front in the Tobacco Wars'>Tobacco Divestment: A New Front in the Tobacco Wars</Link></li>
            </ul>
            <div styleName='answer-subtitle'>
              Resources
            </div>
            <ul>
              <li><Link to={'http://www.asyousow.org/our-work/environmental-health/smoke-free-movies/'} xstrong title='As You Sow: Smoke Free Movies Initiative'>As You Sow&rsquo;s Smoke-Free Movies Initiative</Link></li>
              <li><Link to={'http://smokefreemovies.ca/'} xstrong title='The Ontario Coalition for Smoke-Free Movies'>The Ontario Coalition for Smoke-Free Movies</Link></li>
              <li>World Health Organization Reports
                <ul>
                  <li><Link to={'http://www.who.int/fctc/guidelines/adopted/article_13/en/'} xstrong title='WHO: Guidelines on tobacco advertising, promotion and sponsorship '>Guidelines on tobacco advertising, promotion and sponsorship</Link></li>
                  <li><Link to={'http://www.who.int/tobacco/publications/marketing/smoke-free-movies-third-edition/en/'} xstrong title='WHO: Reports'>Reports</Link></li>
                </ul>
              </li>
              <li><Link to={'https://smokefreemovies.ucsf.edu/'} xstrong title='UCSF Smokefree Movies project'>UCSF Smokefree Movies project</Link></li>
              <li><Link to={'https://www.cdc.gov/tobacco/data_statistics/fact_sheets/youth_data/movies/'} xstrong title='CDC Fact Sheet for Smoking in the Movies'>CDC Fact Sheet for Smoking in the Movies</Link></li>
              <li><Link to={'http://www.tobaccofreeportfolios.org/'} xstrong title='Tobacco Free Portfolios'>Tobacco Free Portfolios</Link></li>
              <li><Link to={'http://truthinitiative.org/'} xstrong title='Truth Initiative'>Truth Initiative</Link></li>
            </ul>
            {this.renderTop()}
          </div>
        </div>

        { /* CONTACT */ }
        <div styleName='answer' >
          <div styleName='anchor' id='contact'/>
          <div styleName='answer-title'>
            Have a question that isn't addressed here? Get in touch with As
            You Sow
          </div>
          <div styleName='answer-info'>
            <p>
              <Link
                xstrong
                styleName='contact'
                to={config.links.contact}
                title='Contact As You Sow'
              >
                Contact<LinkIcon/>
              </Link>
            </p>
            {this.renderTop()}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const faqTitle = 'Frequently asked questions'

    // 
    return (
      <div>
        <div styleName='main'>
          {container.helmet(faqTitle)}

          { /* MAIN CONTENT */ }
          <div styleName='faq'>
            <div styleName='faq-inner'>
              <h1 styleName='title'>
                {faqTitle}
              </h1>

              { /* QUESTIONS */ }
              {this.renderQuestions()}

              { /* ANSWERS */ }
              {this.renderAnswers()}

            </div>
          </div>
        </div>

        { /* GET STARTED PANEL */ }
        <GetStartedInput />

        { /* DONATE ASK PANEL */ }
        <DonateBanner />

        { /* ABOUT PAGE PANEL */ }
        <div styleName='banner-container'>
          <div styleName='banner-inner'>
            <AboutBanner />
          </div>
        </div>
      </div>
    )
  }
}
